module.exports = __webpack_public_path__ + "static/media/icnCerrarModal.7743e33d.svg";